import { SYSTEM_EDITIONS } from "Components/Constants/SystemEditions";
import { CLIENTS } from "./Clients";


export const System = {
  SYSTEM_EDITION: SYSTEM_EDITIONS.BIZ_X_POS,
  CLIENT: CLIENTS.POTLATCH
};


export const company = [{
  Client: CLIENTS.LATHEEF_STORES,
  name: "LATHEEF STORES",
  shortName: "",
  address: "Merza Road, Sainthamaruthu-05",
  phone: "077 921 5498",
  phone2: "075 737 4313",
  email: "",
  logo: "",
},
{
  Client: CLIENTS.KATHEEJAS,
  name: "KATHEEJAS",
  shortName: "",
  address: "Merza Road, Sainthamaruthu-05",
  phone: "077 921 5498",
  phone2: "075 737 4313",
  email: "",
  logo: "",
},
{
  Client: CLIENTS.POWER_POINT,
  name: "Power Point",
  shortName: "",
  address: "Merza Road, Sainthamaruthu-05",
  phone: "077 921 5498",
  phone2: "075 737 4313",
  email: "",
  logo: "",
},
{
  Client: CLIENTS.ALL_FOCUS,
  name: "ALL FOCUS (PVT) LTD",
  shortName: "",
  address: "School Road, Gallella,Polonnaruwa",
  phone: "027 222 2512",
  phone2: "077 324 0392",
  email: "allfoucuspvtltd512@gmail.com",
  logo: "",
},
{
  Client: CLIENTS.ZOOM_TECH,
  name: "Zoom Tech",
  shortName: "",
  address: "No.96, 1st Cross Street, Colombo 11",
  phone: "011 588 32 72",
  phone2: "070 731 91 25",
  email: "zoomtechcctv@gmail.com",
  logo: "",
},
{
  Client: CLIENTS.POTLATCH,
  name: "Potlatch",
  shortName: "",
  address: "No.96, 1st Cross Street, Colombo 11",
  phone: "011 588 32 72",
  phone2: "070 731 91 25",
  email: "zoomtechcctv@gmail.com",
  logo: "",
  backup:"https://titum.org.lk/titum-backup/potlatch-pos"
}

].filter(item => item.Client === System.CLIENT)[0];

